export function isNotNull<T extends NonNullable<any>>(input: T | null): input is T {
  return input !== null
}